import me0 from '../img/medium/0.jpg';
import me1 from '../img/medium/1.jpg';
import me2 from '../img/medium/2.jpg';
import me3 from '../img/medium/3.jpg';
import me4 from '../img/medium/4.jpg';
import me5 from '../img/medium/5.jpg';
import me6 from '../img/medium/6.jpg';
import me7 from '../img/medium/7.jpg';
import me8 from '../img/medium/8.jpg';
import me9 from '../img/medium/9.jpg';
import me10 from '../img/medium/10.jpg';
import me11 from '../img/medium/11.jpg';
import me12 from '../img/medium/12.jpg';
import uniqid from 'uniqid';

const mediumLevelImages = [
  {
    img: me0,
    alt: 'X-MEN',
    id: uniqid(),
  },
  {
    img: me1,
    alt: 'X-MEN 2',
    id: uniqid(),
  },
  {
    img: me2,
    alt: 'X-MEN Apocalypse',
    id: uniqid(),
  },
  {
    img: me3,
    alt: 'X-MEN Days of Future Past',
    id: uniqid(),
  },
  {
    img: me4,
    alt: 'X-MEN First Class',
    id: uniqid(),
  },
  {
    img: me5,
    alt: 'X-MEN The Last Stand',
    id: uniqid(),
  },
  {
    img: me6,
    alt: 'Dark Phoenix',
    id: uniqid(),
  },
  {
    img: me7,
    alt: 'Deadpool',
    id: uniqid(),
  },
  {
    img: me8,
    alt: 'Deadpool 2',
    id: uniqid(),
  },
  {
    img: me9,
    alt: 'The Wolverine',
    id: uniqid(),
  },
  {
    img: me10,
    alt: 'X-Men Origins: Wolverine',
    id: uniqid(),
  },
  {
    img: me11,
    alt: 'Logan',
    id: uniqid(),
  },
  {
    img: me12,
    alt: 'The New Mutants',
    id: uniqid(),
  },
];

export default mediumLevelImages;
